import { t } from "../../i18n";

export function buildDefaultWhatsAppMessage(doctorName?: string, patientName?: string): string {
  const vars = { doctor: doctorName ?? "", patient: patientName ?? "" };
  const about = patientName
    ? doctorName
      ? t("sharing.whatsApp.aboutWithDoctorAndPatient", vars)
      : t("sharing.whatsApp.aboutWithPatient", vars)
    : doctorName
      ? t("sharing.whatsApp.aboutWithDoctor", vars)
      : t("sharing.whatsApp.about");

  const lines = [t("sharing.whatsApp.greeting"), "", about, "", t("sharing.whatsApp.pdfsFollow"), "", t("sharing.whatsApp.closing")];
  if (doctorName) lines.push("", doctorName);
  return lines.join("\n");
}

// Só dígitos contam: o médico pode digitar espaços, parênteses ou traços.
const onlyDigits = (value: string) => value.replace(/\D/g, "");

export function buildWhatsAppUrl(phone: string, message: string): string {
  const digits = onlyDigits(phone);
  // Sem DDI, um número brasileiro tem 10 ou 11 dígitos. Decidir pelo tamanho
  // (e não por "começa com 55") não confunde o DDD 55 (RS) com o DDI.
  const withCountryCode = digits.length <= 11 ? `55${digits}` : digits;
  return `https://wa.me/${withCountryCode}?text=${encodeURIComponent(message)}`;
}
